<template>
  <div>
    <div ref="echart" style="width:500px;height:400px;" class="echart" />
  </div>
</template>

<script>

var echarts = require('echarts')
export default {
  props: ['data'],
  data: function () {
    return {

    }
  },

  methods: {
    getOption (dbData) {
      var xData = dbData.date
      var db1 = dbData.real
      var db2 = dbData.upline
      var db3 = dbData.lowline
      var db4 = dbData.model
      let option = {
        title: {
          text: dbData.title,
          left: 'center'
        },
        legend: {
          top: '8%',
          data: [db1.name, db4.name, dbData.confidence_area]
        },

        grid: {
          left: '5%',
          right: '3%',
          bottom: '3%',
          top: '18%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: xData.value,
          axisLabel: { rotate: '45' },
          splitLine: {
            show: false
          },
          boundaryGap: false
        },
        yAxis: {
          name: '元',
          axisLabel: {},
          axisPointer: {
            label: {}
          },
          splitNumber: 3,
          splitLine: {
            show: true
          },
          min: function (value) { return Math.max(parseInt(value.min - 1), 0) }
        },
        series: [
          {
            name: dbData.confidence_area,
            type: 'bar',
            symbolSize: 1,
            itemStyle: {
              color: '#FFDB5C'
            },
            animation: false,
            symbol: 'none'
          },
          {
            name: db3.name,
            type: 'line',
            data: db3.value.map((v, i) => {
              return {
                value: v,
                label: {
                  show: i === db3.value.length - 1,
                  position: 'top'
                }
              }
            }),
            lineStyle: {
              opacity: 0.5,
              color: '#999'
            },

            stack: 'confidence-band',
            // symbol: 'none',
            symbolSize: 0
          },
          {
            name: db2.name,
            type: 'line',
            data: db2.value.map(function (v, i) {
              return {
                value: v - db3.value[i],
                label: {
                  formatter: () => { return v },
                  show: i === db2.value.length - 1,
                  position: 'top'
                }
              }
            }),
            lineStyle: {
              opacity: 0.5,
              color: '#999'
            },
            areaStyle: {
              color: '#FFDB5C'
            },

            stack: 'confidence-band',
            symbolSize: 0
            // symbol: 'none',
          },
          {
            name: db1.name,
            type: 'line',
            data: db1.value.map((v, i) => {
              return {
                value: v,
                label: {
                  show: i === db1.value.length - 1,
                  position: 'top'
                }
              }
            }),
            hoverAnimation: false,
            symbolSize: 1,
            itemStyle: {
              color: '#8085e8'
            },
            animation: false,
            showSymbol: true,
            markLine: {
              silent: true,
              data: [
                {
                  xAxis: xData.value[db1.value.length - 1]
                }
              ]
            }
          },
          {
            name: db4.name,
            type: 'line',
            data: db4.value.map((v, i) => {
              return {
                value: v,
                label: {
                  show: i === db4.value.length - 1,
                  position: 'top'
                }
              }
            }),
            hoverAnimation: false,
            symbolSize: 1,
            itemStyle: {
              color: '#f15c80'
            },
            animation: false,
            showSymbol: true

          }
        ]
      }
      return option
    }
  },
  components: {

  },
  watch: {

  },
  mounted () {
    if (this.data.img_f30_json && this.data.img_f30_json.data) {
      let option = this.getOption(this.data.img_f30_json.data)
      this.$nextTick(function () {
        echarts.init(this.$refs.echart).setOption(option)
      })
    }
  }
}
</script>
<style lang="less" scoped></style>



// WEBPACK FOOTER //
// src/components/chart/yty_model/lastStockPriceForecast.vue